vsr-product-card {
  --font-family: "Visa Dialect", sans-serif;
  display: block;
  font-family: var(--font-family);
  box-sizing: border-box;
}

.vsr-product-card-theme-light {
  --color-card-bg: #f7f7f7;
  --color-title-text: #1a1a1a;
  --color-title-hover: #1434cb;
}

.vsr-product-card-theme-dark {
  --color-card-bg: #2c2c2c;
  --color-title-text: #ffffff;
  --color-title-hover: #8f9fe4;
}

.vsr-product-card {
  display: flex;
  flex-direction: column;
  border: none;
  box-shadow: none;
  width: auto;
  box-sizing: border-box;
  max-width: 300px;
  @media (max-width: 480px) {
    max-width: none;
  }
}

.vsr-product-card__image-container {
  width: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f6f6f6;
  overflow: hidden;
  @media (max-width: 480px) {
    width: auto;
  }
}

.vsr-product-card__image-container.b-radius {
  border-radius: 2%;
}

.vsr-product-card__image {
  position: relative;
  overflow: hidden;
  width: 100%;
  object-fit: cover;
  object-position: center;
  max-width: 300px;
  display: block;
  transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.735);
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.4s;
  }
  @media (max-width: 480px) {
    max-width: none;
  }
}

.vsr-product-card__image-container.variant1 {
  & .vsr-product-card__image {
    height: 400px;
  }
}

.vsr-product-card__image-container.variant2 {
  & .vsr-product-card__image {
    max-height: 169px;
  }
}

.vsr-product-card__content {
  margin-top: 16px;
}

.vsr-product-card__label,
.vsr-product-card__title,
.vsr-product-card__description {
  word-break: break-word;
  overflow-wrap: break-word;
  white-space: normal;
  width: 100%;
  box-sizing: border-box;
  text-decoration: none;
  p {
    margin: 0;
  }
}

.vsr-product-card__label {
  font-size: 0.75rem;
  font-weight: 500;
  line-height: 1.3;
  color: #767676;
  margin: 0 0 0.5rem;
}

.vsr-product-card__title {
  font-size: 1.25rem;
  font-weight: 400;
  line-height: 1.3;
  color: var(--color-title-text);
  margin: 0 0 0.5rem;
  cursor: default;
  border-radius: 4px;
  // padding: 2px 4px;
  transition:
    color 0.2s,
    outline 0.2s;
}

.vsr-product-card__title:focus {
  outline: 2px dashed var(--color-title-hover);
  outline-offset: 2px;
  color: var(--color-title-hover);
}

.vsr-product-card__title:focus:not(:focus-visible) {
  outline: none;
}

.vsr-product-card__link {
  text-decoration: none;
  color: inherit;
  display: block;
  cursor: pointer;

  &:hover,
  &:focus,
  &:active,
  &:visited {
    text-decoration: none;
    color: inherit;
  }
}

.vsr-product-card__description {
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--color-title-text);
  margin: 0 0 0.5rem;
}

.vsr-product-card__actions-row {
  display: flex;
  gap: 16px;
  margin-top: 0.75em;
  @media (max-width: 325px) {
    flex-direction: column;
  }
}

.vsr-product-card__action-button {
  font-size: 0.875rem;
  color: var(--color-title-text);
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  gap: 2px;
  font-weight: 400;
  line-height: 1.4;
  transition: color 0.2s;
  font-family: "Visa Dialect", sans-serif;
  text-decoration: none;
  &:hover {
    color: var(--color-title-hover);
  }
}

.vsr-product-card__action-button svg {
  margin-left: 6px;
  display: inline-block;
  vertical-align: middle;
}

.vsr-product-card__fixed-image {
  height: 300px;
  background-color: var(--color-card-bg);
  display: flex;
  justify-content: center;
  align-items: center;
}

@media (max-width: 900px) {
  .vsr-product-card__fixed-image {
    width: auto;
  }
}

.vsr-product-card__fixed-image img {
  max-width: 170px;
  max-height: 100%;
  object-fit: contain;
  transition: transform 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

/* Aspect ratio classes for product card */
.vsr-product-card__fixed-image.aspect-ratio-3-4 .vsr-produc-card__image {
  height: auto;
  //aspect-ratio: 3 / 4;
}

.vsr-product-card__fixed-image.aspect-ratio-4-3 .vsr-produc-card__image {
  height: auto;
  //aspect-ratio: 4 / 3;
}

.vsr-product-card__fixed-image.aspect-ratio-4-5 .vsr-produc-card__image {
  height: auto;
  //aspect-ratio: 4 / 5;
}

.vsr-product-card__fixed-image.aspect-ratio-16-9 .vsr-produc-card__image {
  height: auto;
  //aspect-ratio: 16 / 9;
}

.vsr-product-card__fixed-image.aspect-ratio-1-1 .vsr-produc-card__image {
  height: auto;
  //aspect-ratio: 1 / 1;
}

@keyframes flash-in {
  0% {
    opacity: 0.5;
  }
}

/* Removing hover effect for product card images as per requirement */
.vsr-product-card:hover .vsr-product-card__fixed-image img {
  transform: none;
}

.vsr-product-card.has-card-link:not(.no-hover-16-9):hover .vsr-product-card__title {
  color: var(--color-title-hover);
}

/* Remove hover effect on title for 16:9 aspect ratio */
.vsr-product-card.no-hover-16-9 .vsr-product-card__title:hover {
  color: var(--color-title-text);
}

.vsr-product-card__action-button:hover {
  text-decoration: none;
  color: var(--color-title-hover);
}

.vsr-product-card__action-button:hover svg {
  transition:
    width 0.2s ease-in-out,
    height 0.2s ease-in-out;
  margin-left: 8px;
}
